/* eslint-disable @typescript-eslint/explicit-function-return-type */
import _ from 'lodash';
import { casaTurnedOffFeatures } from '../config/casa-features';

function isFeatureEnabled(feature) {
  return !_.includes(casaTurnedOffFeatures, feature);
}

export { isFeatureEnabled };
